import withTheme from "../../hooks/withTheme";
import AccessDeniedError from "./AccessDeniedError";

export default withTheme(AccessDeniedError);
